import Reflux from 'reflux';
import modalActions from '../../actions/modal';
import storeUtils from '../../utils/store';
import noScroll from '../../utils/noscroll';

export default class ModalStore extends Reflux.Store {
  static id = 'modal';

  constructor () {
    super();

    this.state = {};
    this.listenTo(modalActions.show, 'show');
    this.listenTo(modalActions.hide, 'hide');

    const data = storeUtils.get('information_topics');
    data.showModalOnLoad = data.informationLightbox &&
                           !data.informationLightbox.isHidden &&
                           data.informationLightbox.infoTopics &&
                           data.informationLightbox.infoTopics.length > 0;
    data.showModal = data.showModalOnLoad;
    this.setState(data);
  }

  show () {
    if (this.state && !this.state.showModal) {
      this.setState({ showModal: true });
    }
  }

  hide () {
    noScroll.off();
    if (this.state && this.state.showModal) {
      this.setState({
        showModal: false,
        showModalOnLoad: false
      });
    }
  }
}



// WEBPACK FOOTER //
// ./frontend/react/stores/modal/index.js